<template>
    <div v-if="pickupTime" class="row mb-2 g-2">
        <div class="col-6">
            <div class="border rounded p-2">
                <div class="text-muted small">Pick-up time</div>
                <div class="small fw-semibold">{{ formatTime(pickupTime) }}</div>
                <div class="text-muted" style="font-size:0.7rem;">First GPS point: {{ firstPointTime }}</div>
            </div>
        </div>
        <div class="col-6">
            <div class="border rounded p-2">
                <div class="text-muted small">Drop-off time</div>
                <div class="small fw-semibold">{{ formatTime(dropoffTime) }}</div>
                <div class="text-muted" style="font-size:0.7rem;">
                    Last GPS point: {{ lastPointTime }}
                    <span class="text-info">(+5 min window)</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { formatTime } from "../composables/useGpsAnalytics";

defineProps<{
    pickupTime?: string | null;
    dropoffTime?: string | null;
    firstPointTime: string;
    lastPointTime: string;
}>();
</script>
